import { AsyncIterableX } from '../../asynciterable/asynciterablex';
import { scan } from '../../asynciterable/scan';

export function scanProto<T, R = T>(
  this: AsyncIterableX<T>,
  accumulator: (previousValue: R, currentValue: T, currentIndex: number) => R,
  seed?: never[]
): AsyncIterableX<R>;
export function scanProto<T, R = T>(
  this: AsyncIterableX<T>,
  accumulator: (previousValue: R, currentValue: T, currentIndex: number) => R,
  seed?: R
): AsyncIterableX<R>;
/**
 * @ignore
 */
export function scanProto<T, R = T>(
  this: AsyncIterableX<T>,
  accumulator: (previousValue: R, currentValue: T, currentIndex: number) => R,
  ...seed: R[]
): AsyncIterableX<R> {
  return scan(this, accumulator, ...seed);
}

AsyncIterableX.prototype.scan = scanProto;

declare module '../../asynciterable/asynciterablex' {
  interface AsyncIterableX<T> {
    scan: typeof scanProto;
  }
}



// WEBPACK FOOTER //
// ./node_modules/ix/add/asynciterable-operators/scan.ts